export type StartTmmLaunchInput = {
	locale: string;
	redirectUrl: string;
	fetchImpl?: typeof fetch;
};

export async function startTmmLaunch({
	locale,
	redirectUrl,
	fetchImpl,
}: StartTmmLaunchInput): Promise<string> {
	const f = fetchImpl ?? fetch;
	const res = await f('/api/tmm/launch', {
		method: 'POST',
		credentials: 'include',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({locale, redirectUrl}),
	});
	const json = (await res.json()) as {redirectUrl?: string; code?: string};

	if (!res.ok || !json.redirectUrl) {
		throw new Error(json.code ?? 'TMM_LAUNCH_FAILED');
	}

	return json.redirectUrl;
}
